import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-historico-papel-lotacao`

    return {
        index(queryParms) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        usuario: {
            autocomplete(queryParms) {
                return repository.get(`${baseUrl}/autocomplete-usuario?${urlUtil.serialize(queryParms)}`)
            },
        },
        usuarioResponsavel: {
            autocomplete(queryParms) {
                return repository.get(`${baseUrl}/autocomplete-usuario-responsavel?${urlUtil.serialize(queryParms)}`)
            },
        },
    }
}